module.exports = __webpack_public_path__ + "static/media/product_wein.816f01de.png";